var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.campaignContent)?_c('content-preview-page',{attrs:{"description":_vm.campaign.description,"title":_vm.campaign.name,"content":_vm.campaignContent,"is-completed":_vm.campaign.status === "completed"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }